import { RELATORIO } from '../actions/types';

const INITIAL_STATE = {
    loading: false,
    route: 'admin',
    list: {
        data: [],
        "total": 0,
        "perPage": 10,
        "page": 1,
        "lastPage": 1,
    },
    totalAssinado: 0,
    totalAssinaturas: 0
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case RELATORIO:
            return { 
                ...state, 
                ...action.payload,
            }
        default:
            return state
    }
};
